module.exports = __webpack_public_path__ + "static/media/Nastaliq.6494901b.ttf";